<template>
  <div class="data">data</div>
</template>

<script>
export default {
    name: 'data'
}
</script>

<style lang="less" scoped>

</style>
